import type { ClassValue } from 'clsx';
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Make tailwind-merge aware of custom values
const twMerge = extendTailwindMerge<'col' | 'flow-space'>({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            (value: string) =>
              value.startsWith('static-') || value.startsWith('fluid-'),
          ],
        },
      ],
      'grid-cols': [
        'grid-cols-layout',
        'grid-cols-content-mobile',
        'grid-cols-content',
        'grid-cols-content-collapsed',
      ],
      col: [
        {
          col: [
            (value: string) =>
              [
                'content',
                'feature',
                'full',
                'leftside',
                'rightside',
                'drawer',
              ].includes(value),
          ],
        },
      ],
      'flow-space': [
        { flow: [(value: string) => value !== '' && value !== 'undefined'] },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs));
}
